import { MdSportsSoccer } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupFocusMatchConfig;

export const list = MainPage;

export const icon = MdSportsSoccer;

export const options = { label: 'resource.worldCupFocusMatchConfig' };
